import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  TeacherLayout,
  TeacherDashboard,
  TeacherBatches,
  TeacherStudents,
  TeacherMaterials,
  TeacherQuestions,
  TeacherSettings,
} from "../teachers";
import TeacherSchedule from "../teachers/TeacherSchedule";
import TeacherTests from "../teachers/TeacherTests";

// ✅ Unified Auth Check
export const getTeacherAuth = () => {
  try {
    return JSON.parse(localStorage.getItem("mediit_admin_auth") || "null");
  } catch {
    return null;
  }
};



const ProtectedTeacherRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = getTeacherAuth();

  if (!auth?.isAuthenticated) {
    return <Navigate to="/LMS/login" replace />;
  }

  const role = String(auth.role || "").toLowerCase();
  if (role !== "teacher") {
    // Agar koi Admin galti se idhar aaye to usko uske panel me bhej do
    return <Navigate to="/learn-with-us" replace />;
  }

  return <>{children}</>;
};

const TeacherRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedTeacherRoute>
            <TeacherLayout />
          </ProtectedTeacherRoute>
        }
      >
        {/* ✅ Default route will hit /teach-with-us/dashboard */}
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<TeacherDashboard />} />
        <Route path="batches" element={<TeacherBatches />} />
        <Route path="students" element={<TeacherStudents />} />
        <Route path="materials" element={<TeacherMaterials />} />
        <Route path="settings" element={<TeacherSettings />} />
        <Route path="schedule" element={<TeacherSchedule />} />
        <Route path="tests" element={<TeacherTests />} />
        <Route path="questions" element={<TeacherQuestions />} />

        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Route>
    </Routes>
  );
};

export default TeacherRoutes;